import React, { useState, useEffect, useRef } from 'react';
import './MultiSelectSkills.css';
import { SkillCategoryNames } from '../services/api';

const MultiSelectSkills = ({
  availableSkills = [],
  selectedSkills = [],
  onSkillsChange,
  placeholder = 'Select skills...',
  label = 'Skills'
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const filteredSkills = availableSkills.filter((skill) =>
    skill.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Group skills by category
  const groupedSkills = filteredSkills.reduce((acc, skill) => {
    const category = SkillCategoryNames[skill.category] || 'Other';
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(skill);
    return acc;
  }, {});

  const handleSkillToggle = (skill) => {
    const isSelected = selectedSkills.some(s => s.id === skill.id);
    if (isSelected) {
      onSkillsChange(selectedSkills.filter(s => s.id !== skill.id));
    } else {
      onSkillsChange([...selectedSkills, skill]);
    }
  };

  const handleRemoveSkill = (skillId) => {
    onSkillsChange(selectedSkills.filter(s => s.id !== skillId));
  };

  return (
    <div className="multi-select-skills" ref={dropdownRef}>
      {label && <label className="multi-select-label">{label}</label>}

      {/* Selected Skills Chips */}
      {selectedSkills.length > 0 && (
        <div className="selected-skills-chips">
          {selectedSkills.map((skill) => (
            <div key={skill.id} className="skill-chip">
              <span>{skill.name}</span>
              <button
                type="button"
                className="chip-remove"
                onClick={() => handleRemoveSkill(skill.id)}
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      {/* Dropdown Trigger */}
      <div
        className="multi-select-trigger"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="trigger-text">
          {selectedSkills.length === 0 ? placeholder : `${selectedSkills.length} skill(s) selected`}
        </span>
        <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </div>

      {/* Dropdown Menu */}
      {isOpen && (
        <div className="multi-select-dropdown">
          <input
            type="text"
            className="skill-search-input"
            placeholder="Search skills..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onClick={(e) => e.stopPropagation()}
          />

          <div className="skills-list">
            {Object.keys(groupedSkills).length === 0 ? (
              <div className="no-results">No skills found</div>
            ) : (
              Object.keys(groupedSkills)
                .sort()
                .map((category) => (
                  <div key={category} className="skill-category-group">
                    <div className="category-header">{category}</div>
                    {groupedSkills[category].map((skill) => {
                      const isSelected = selectedSkills.some(s => s.id === skill.id);
                      return (
                        <div
                          key={skill.id}
                          className={`skill-option ${isSelected ? 'selected' : ''}`}
                          onClick={() => handleSkillToggle(skill)}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => {}}
                            onClick={(e) => e.stopPropagation()}
                          />
                          <span className="skill-name">{skill.name}</span>
                        </div>
                      );
                    })}
                  </div>
                ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default MultiSelectSkills;
